rebru.vars = {
    global : {
        scrollPos : 0,
        scrollPositions: []
    }
};